import React from 'react'

// @ts-ignore
import { SignaturePad } from './vendor/ReactSignaturePad'

export const PAD_WIDTH = 600

// TODO: rewrite without mutations and class using HOCs

const builder = (context, props) => {
  class Hoc extends React.Component {
    constructor(...args) {
      super(...args)

      this.listeners = []
    }

    componentDidMount() {
      this.listeners = [
        ...this.listeners,
        context.onClear(() => {
          this.pad.clear()
        }),
      ]

      this.listeners = [
        ...this.listeners,
        context.onGet(() => {
          if (!this.pad.isEmpty()) {
            return this.pad.toDataURL()
          }
        }),
      ]
    }

    componentWillUnmount() {
      this.listeners.map((unsubscribe) => {
        return unsubscribe()
      })
    }

    render() {
      const style = {
        border: '1px solid #B9C5CF',
        borderRadius: '8px',
        backgroundColor: '#fff',
      }

      const width = Math.min(PAD_WIDTH, window.innerWidth - 30)
      const height = width / 2

      return (
        <SignaturePad
          {...props}
          {...{
            ref: (pad) => (this.pad = pad),
            style,
            width,
            height,
          }}
        />
      )
    }
  }

  return <Hoc />
}

export const SignaturePadContainer = () => {
  let onClear = []
  let onGet = []

  const clear = () => {
    return onClear.map((m) => m())
  }

  const get = () => {
    return onGet.map((m) => m())
  }

  const unsubscribe = (callbacks, callback) => {
    return callbacks.filter((c) => {
      return c !== callback
    })
  }

  const context = {
    onGet(callback) {
      onGet = [...onGet, callback]
      return () => {
        onGet = unsubscribe(onGet, callback)
        return this
      }
    },
    onClear(callback) {
      onClear = [...onClear, callback]
      return () => {
        onClear = unsubscribe(onClear, callback)
        return this
      }
    },
  }

  return {
    clear,
    get,
    component(props) {
      return builder(context, props)
    },
  }
}
